<div class="content">
    <!-- Begin dashboard -->
    <div class="container-fluid">
        <!-- Page Heading -->
        <div class="row">
            <div class="col d-flex align-items-center justify-content-between mb-4">
                <h1 class="dashboard-title">HMO</h1>
            </div>
        </div>

        <!-- Content Row -->
        <!-- <div class="row align-items-center"> -->
<!-- Content Row -->
        <div class="row align-items-center hmo-toolbar">

            <!-- SEARCH -->
            <div
                class="col-md-12 col-sm-12 hmo-search-column"
                [ngClass]="assignArray.length !== 0 ? 'col-lg-5' : 'col-lg-6'">

                <div class="google-search-container">

                    <i class="fa fa-search search-icon"></i>

                    <input
                        (keyup)="handleKeyUp($event)"
                        #searchBox
                        class="google-search-input"
                        type="text"
                        placeholder="Search"
                    />

                    <i
                        *ngIf="searchBox.value"
                        class="fa fa-times clear-icon"
                        (click)="clearSearch(searchBox)">
                    </i>

                </div>
            </div>


            <!-- AGENT ASSIGNMENT -->
            <div class="col-lg-3 col-md-6 col-sm-12 hmo-agent-column">

                <fieldset
                    [disabled]="!authService.hasRole('client-edit')"
                    class="w-100">

                    <div class="hmo-assignment-control">

                        <mat-form-field
                            appearance="outline"
                            class="hmo-agent-select">

                            <span matPrefix class="hmo-agent-prefix">
                                <i class="fa-regular fa-user"></i>
                            </span>

                            <mat-select
                                [(ngModel)]="userId"
                                placeholder="Select Agent"
                                [disabled]="!authService.hasRole('client-edit')">

                                <!-- Selected agent label -->
                                <mat-select-trigger>
                                    <span class="hmo-agent-selected-text">
                                        {{ getSelectedAgentName(userId) }}
                                    </span>
                                </mat-select-trigger>

                                <mat-select-filter
                                    #filterSelect
                                    [array]="agentArray"
                                    [displayMember]="'fullName'"
                                    (filteredReturn)="onFilteredReturn($event)">
                                </mat-select-filter>

                                <mat-option
                                    *ngFor="let agent of filterAgentArray; trackBy: trackByAgentId"
                                    [value]="agent.id">

                                    {{ agent.firstName }} {{ agent.lastName }}

                                </mat-option>

                            </mat-select>

                        </mat-form-field>


                        <!-- Assign / Unassign -->
                        <div
                            *ngIf="assignArray.length !== 0"
                            class="hmo-assignment-actions">

                            <button
                                type="button"
                                class="listing-btn listing-btn-secondary listing-btn-icon"
                                (click)="assignAgent(true)"
                                [disabled]="!userId"
                                title="Assign selected patients">

                                <i class="fa-solid fa-user-check"></i>

                            </button>

                            <button
                                type="button"
                                class="listing-btn listing-btn-secondary listing-btn-icon"
                                (click)="assignAgent(false)"
                                title="Un-assign selected patients">

                                <i class="fa-solid fa-user-minus"></i>

                            </button>

                        </div>

                    </div>

                </fieldset>

            </div>


            <!-- ACTIONS -->
            <div
                class="col-md-6 col-sm-12 hmo-actions-column"
                [ngClass]="assignArray.length !== 0 ? 'col-lg-4' : 'col-lg-3'">

                <div
                    class="listing-toolbar-actions hmo-action-bar"
                    [class.has-selection]="assignArray.length !== 0">


                    <!-- RECOVER / DELETE -->
                    <div
                        *ngIf="assignArray.length !== 0"
                        class="listing-selection-actions">

                        <button
                            type="button"
                            class="listing-btn listing-btn-success"
                            (click)="changeStatus(true)"
                            title="Recover">

                            <i class="fa-solid fa-rotate-left"></i>

                            <span class="listing-btn-label">
                                Recover
                            </span>

                        </button>


                        <button
                            type="button"
                            class="listing-btn listing-btn-danger"
                            (click)="changeStatus(false)"
                            title="Delete">

                            <i class="fa-solid fa-trash-can"></i>

                            <span class="listing-btn-label">
                                Delete
                            </span>

                        </button>

                    </div>


                    <!-- FILTER -->
                    <div
                        class="hmo-filter-wrapper"
                        #dropdownContainer>

                        <button
                            type="button"
                            class="
                                listing-btn
                                listing-btn-secondary
                                listing-filter-btn
                                listing-shrink-on-selection
                                btn-filter
                            "
                            [class.active]="isDropdownOpen"
                            (click)="toggleDropdown()"
                            title="Filters">

                            <i class="fa-solid fa-sliders"></i>

                            <span class="listing-btn-label">
                                Filters
                            </span>

                            <span
                                *ngIf="
                                    filter.filterType &&
                                    filter.filterType !== 'initial'
                                "
                                class="listing-filter-count">
                                1
                            </span>

                        </button>


                        <!-- FILTER POPOVER -->
                        <div
                            class="hmo-filter-popover"
                            *ngIf="isDropdownOpen"
                            (click)="$event.stopPropagation()">


                            <!-- HEADER -->
                            <div class="hmo-filter-header">

                                <div>
                                    <div class="hmo-filter-title-row">

                                        <span class="hmo-filter-title">
                                            Filters
                                        </span>

                                        <span
                                            *ngIf="
                                                filter.filterType &&
                                                filter.filterType !== 'initial'
                                            "
                                            class="hmo-filter-active-badge">

                                            Active

                                        </span>

                                    </div>

                                    <div class="hmo-filter-subtitle">
                                        Choose a filter to refine the HMO work list.
                                    </div>
                                </div>


                                <button
                                    type="button"
                                    class="hmo-filter-close"
                                    (click)="toggleDropdown()">

                                    <i class="fa-solid fa-xmark"></i>

                                </button>

                            </div>


                            <!-- BODY -->
                            <div class="hmo-filter-body">

                                <!-- Dental / Medical / Both patient benefit -->
                                <div class="hmo-filter-section">
                                    <div class="hmo-filter-label">Patient Benefit Type</div>
                                    <div class="hmo-benefit-options" role="group" aria-label="Patient benefit type">
                                        <button type="button" class="hmo-filter-type"
                                                [class.active]="filter.patientBenefitType === 'DENTAL'"
                                                [attr.aria-pressed]="filter.patientBenefitType === 'DENTAL'"
                                                (click)="changePatientBenefitType('DENTAL')">Dental</button>
                                        <button type="button" class="hmo-filter-type"
                                                [class.active]="filter.patientBenefitType === 'MEDICAL'"
                                                [attr.aria-pressed]="filter.patientBenefitType === 'MEDICAL'"
                                                (click)="changePatientBenefitType('MEDICAL')">Medical</button>
                                        <button type="button" class="hmo-filter-type"
                                                [class.active]="filter.patientBenefitType === 'BOTH'"
                                                [attr.aria-pressed]="filter.patientBenefitType === 'BOTH'"
                                                (click)="changePatientBenefitType('BOTH')">Both</button>
                                    </div>
                                    <button class="hmo-benefit-apply" type="button"
                                            (click)="applyPatientBenefitType()">Apply Benefit Filter</button>
                                </div>

                                <!-- FILTER TYPE -->
                                <div class="hmo-filter-section">

                                    <div class="hmo-filter-label">
                                        Filter By
                                    </div>

                                    <div class="hmo-filter-type-grid">

                                        <button
                                            type="button"
                                            class="hmo-filter-type"
                                            [class.active]="filter.filterType === 'date'"
                                            (click)="setFilterType('date')">

                                            <i class="fa-regular fa-calendar"></i>
                                            Appointment

                                        </button>


                                        <button
                                            type="button"
                                            class="hmo-filter-type"
                                            [class.active]="filter.filterType === 'wdate'"
                                            (click)="setFilterType('wdate')">

                                            <i class="fa-regular fa-clock"></i>
                                            WOD

                                        </button>


                                        <button
                                            type="button"
                                            class="hmo-filter-type"
                                            [class.active]="
                                                filter.filterType === 'status' ||
                                                filter.filterType === 'active' ||
                                                filter.filterType === 'inactive'
                                            "
                                            (click)="setFilterType('status')">

                                            <i class="fa-solid fa-circle-check"></i>
                                            Status

                                        </button>


                                        <button
                                            type="button"
                                            class="hmo-filter-type"
                                            [class.active]="filter.filterType === 'verification'"
                                            (click)="setFilterType('verification')">

                                            <i class="fa-solid fa-shield-check"></i>
                                            Verification

                                        </button>


                                        <button
                                            type="button"
                                            class="hmo-filter-type"
                                            [class.active]="filter.filterType === 'agent'"
                                            (click)="setFilterType('agent')">

                                            <i class="fa-regular fa-user"></i>
                                            Agent

                                        </button>

                                        <button
                                            type="button"
                                            class="hmo-filter-type"
                                            [class.active]="filter.filterType === 'payer'"
                                            (click)="setFilterType('payer')">
                                            <i class="fa-solid fa-building-shield"></i>
                                            Payer
                                        </button>

                                    </div>

                                </div>


                                <!-- APPOINTMENT DATE -->
                                <div
                                    *ngIf="filter.filterType === 'date'"
                                    class="hmo-filter-section">

                                    <div class="hmo-filter-section-heading">

                                        <span class="hmo-filter-section-icon">
                                            <i class="fa-regular fa-calendar"></i>
                                        </span>

                                        <div>
                                            <div class="hmo-filter-section-title">
                                                Appointment Date
                                            </div>

                                            <div class="hmo-filter-section-hint">
                                                Filter by scheduled appointment date.
                                            </div>
                                        </div>

                                    </div>


                                    <div class="hmo-filter-date-grid">

                                        <div class="hmo-filter-field">

                                            <label>From</label>

                                            <input
                                                type="text"
                                                id="startDate"
                                                #startDateInput
                                                class="form-control hmo-filter-input"
                                                placeholder="MM/DD/YYYY"
                                                bsDatepicker
                                                [(ngModel)]="startDate"
                                                [bsConfig]="{
                                                    dateInputFormat: 'MM/DD/YYYY',
                                                    placement: 'bottom',
                                                    containerClass: 'theme-blue'
                                                }">

                                        </div>


                                        <div class="hmo-filter-field">

                                            <label>To</label>

                                            <input
                                                type="text"
                                                id="endDate"
                                                #endDateInput
                                                class="form-control hmo-filter-input"
                                                placeholder="MM/DD/YYYY"
                                                bsDatepicker
                                                [(ngModel)]="endDate"
                                                [minDate]="startDate"
                                                [bsConfig]="{
                                                    dateInputFormat: 'MM/DD/YYYY',
                                                    placement: 'bottom',
                                                    containerClass: 'theme-blue'
                                                }">

                                        </div>

                                    </div>

                                </div>


                                <!-- WOD -->
                                <div
                                    *ngIf="filter.filterType === 'wdate'"
                                    class="hmo-filter-section">

                                    <div class="hmo-filter-section-heading">

                                        <span class="hmo-filter-section-icon">
                                            <i class="fa-regular fa-clock"></i>
                                        </span>

                                        <div>
                                            <div class="hmo-filter-section-title">
                                                Work Order Date
                                            </div>

                                            <div class="hmo-filter-section-hint">
                                                Filter by work order creation date.
                                            </div>
                                        </div>

                                    </div>


                                    <div class="hmo-filter-date-grid">

                                        <div class="hmo-filter-field">

                                            <label>From</label>

                                            <input
                                                type="text"
                                                id="wstartDate"
                                                class="form-control hmo-filter-input"
                                                placeholder="MM/DD/YYYY"
                                                bsDatepicker
                                                [(ngModel)]="wstartDate"
                                                [bsConfig]="{
                                                    dateInputFormat: 'MM/DD/YYYY',
                                                    placement: 'bottom',
                                                    containerClass: 'theme-blue'
                                                }">

                                        </div>


                                        <div class="hmo-filter-field">

                                            <label>To</label>

                                            <input
                                                type="text"
                                                id="wendDate"
                                                class="form-control hmo-filter-input"
                                                placeholder="MM/DD/YYYY"
                                                bsDatepicker
                                                [(ngModel)]="wendDate"
                                                [minDate]="wstartDate"
                                                [bsConfig]="{
                                                    dateInputFormat: 'MM/DD/YYYY',
                                                    placement: 'bottom',
                                                    containerClass: 'theme-blue'
                                                }">

                                        </div>

                                    </div>

                                </div>


                                <!-- STATUS -->
                                <div
                                    *ngIf="filter.filterType === 'status'"
                                    class="hmo-filter-section">

                                    <div class="hmo-filter-label">
                                        Status
                                    </div>

                                    <div class="hmo-filter-choice-grid">

                                        <button
                                            type="button"
                                            class="hmo-filter-choice"
                                            (click)="_fetchData('active'); setFilterType('active','status')">

                                            Active

                                        </button>

                                        <button
                                            type="button"
                                            class="hmo-filter-choice"
                                            (click)="_fetchData('inactive'); setFilterType('status','inactive')">

                                            Inactive

                                        </button>

                                        <button
                                            type="button"
                                            class="hmo-filter-choice"
                                            (click)="_fetchData('all'); setFilterType('status','all')">

                                            All

                                        </button>

                                    </div>

                                </div>


                                <!-- VERIFICATION -->
                                <div
                                    *ngIf="filter.filterType === 'verification'"
                                    class="hmo-filter-section">

                                    <div class="hmo-filter-label">
                                        Verification
                                    </div>

                                    <div class="hmo-filter-choice-grid verification">

                                        <button
                                            type="button"
                                            class="hmo-filter-choice"
                                            (click)="_fetchData('VERIFIED'); setFilterType('verification','VERIFIED')">
                                            Verified
                                        </button>

                                        <button
                                            type="button"
                                            class="hmo-filter-choice"
                                            (click)="_fetchData('PENDING'); setFilterType('verification','PENDING')">
                                            In Progress
                                        </button>

                                        <button
                                            type="button"
                                            class="hmo-filter-choice"
                                            (click)="_fetchData('NOT_VERIFIED'); setFilterType('verification','NOT_VERIFIED')">
                                            Not Verified
                                        </button>

                                        <button
                                            type="button"
                                            class="hmo-filter-choice"
                                            (click)="_fetchData('BACKLOG'); setFilterType('verification','BACKLOG')">
                                            Backlog
                                        </button>

                                        <button
                                            type="button"
                                            class="hmo-filter-choice"
                                            (click)="_fetchData('UNASSIGNED'); setFilterType('verification','UNASSIGNED')">
                                            Unassigned
                                        </button>

                                    </div>

                                </div>


                                <!-- PAYER -->
                                <div
                                    *ngIf="filter.filterType === 'payer'"
                                    class="hmo-filter-section">

                                    <div class="hmo-filter-label">
                                        Payer Name
                                    </div>

                                    <mat-form-field appearance="outline" class="hmo-filter-agent-select w-100">
                                        <mat-select
                                            [(ngModel)]="filter.payerId"
                                            placeholder="Search and select payer">

                                            <mat-option [value]="null">All Payers</mat-option>

                                            <mat-select-filter
                                                [array]="payerArray"
                                                [displayMember]="'name'"
                                                (filteredReturn)="onPayerFilteredReturn($event)">
                                            </mat-select-filter>

                                            <mat-option
                                                *ngFor="let payer of filterPayerArray"
                                                [value]="payer.id">
                                                {{ payer.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- AGENT -->
                                <div
                                    *ngIf="filter.filterType === 'agent'"
                                    class="hmo-filter-section">

                                    <div class="hmo-filter-label">
                                        Agent
                                    </div>

                                    <mat-form-field
                                        appearance="outline"
                                        class="hmo-filter-agent-select w-100">

                                        <mat-select
                                            [(ngModel)]="agentId"
                                            (selectionChange)="_fetchData()"
                                            placeholder="Search and select agent">

                                            <mat-select-filter
                                                #filterSelect
                                                [array]="agentArray"
                                                [displayMember]="'fullName'"
                                                (filteredReturn)="onFilteredReturn($event)"
                                                (click)="$event.stopPropagation()">
                                            </mat-select-filter>

                                            <mat-option
                                                *ngFor="let agent of filterAgentArray; trackBy: trackByAgentId"
                                                [value]="agent.id">

                                                {{ agent.firstName }}
                                                {{ agent.lastName }}

                                            </mat-option>

                                        </mat-select>

                                    </mat-form-field>

                                </div>

                            </div>


                            <!-- FOOTER -->
                            <div class="hmo-filter-footer">

                                <button
                                    type="button"
                                    class="listing-btn listing-btn-secondary"
                                    (click)="resetFilter($event)">

                                    <i class="fa-solid fa-rotate-left"></i>
                                    Reset

                                </button>


                                <button
                                    *ngIf="
                                        filter.filterType === 'date' ||
                                        filter.filterType === 'wdate'
                                    "
                                    type="button"
                                    class="listing-btn listing-btn-primary"
                                    (click)="_fetchData(); toggleDropdown()">

                                    <i class="fa-solid fa-check"></i>
                                    Apply Filter

                                </button>

                            </div>

                        </div>

                    </div>


                    <!-- UPLOAD -->
                    <button
                        type="button"
                        class="
                            listing-btn
                            listing-btn-primary
                            listing-shrink-on-selection
                            btn-upload
                        "
                        (click)="openModal()"
                        title="Bulk Upload"
                        [disabled]="!authService.hasRole('client-edit')">

                        <i class="fa-solid fa-cloud-arrow-up"></i>

                        <span class="listing-btn-label">
                            Upload
                        </span>

                    </button>

                </div>

            </div>

        <!-- </div> -->


            <!-- Table -->
            <div class="col-12">

                    <div class="table-panel p-4">
                        <div class="table-responsive table-scroll-x">
                            <table class="table table-sm" matSort (matSortChange)="sortData($event)">
                                <thead>
                                <tr>
                                    <th scope="col">Sr.No</th>
                                    <th scope="col">Batch-Status</th>
                                    <th *ngIf="this.authService.hasRole('client-edit')" scope="col"><input
                                            type="checkbox" [checked]="checked" (click)="assign('All')">&nbsp;
                                        Select
                                    </th>
                                    <th scope="col">Assigned-To</th>
                                    <th scope="col">Verification</th>
                                    <th mat-sort-header="firstName" scope="col">Name</th>
                                    <th mat-sort-header="dob" scope="col">DOB</th>
                                    <th mat-sort-header="patientId" scope="col">PatientId</th>
                                    <th mat-sort-header="formType" scope="col">Form Type</th>
                                    <th mat-sort-header="insuranceType" scope="col">Ins-Type</th>
                                    <th mat-sort-header="payerName" scope="col">Career Name</th>
                                    <th mat-sort-header="careerName" scope="col">Payer ID</th>
                                    <th mat-sort-header="insuranceID" scope="col">Ins-Id</th>
                                    <th mat-sort-header="insurancePhone" scope="col">Ins-phone</th>
                                    <th mat-sort-header="apptDate" scope="col">App-Date</th>
                                    <th mat-sort-header="apptTime" scope="col">App-Time</th>
                                    <th mat-sort-header="providerName" scope="col">Provider Name</th>
                                    <th mat-sort-header="officeName" scope="col">Office</th>
                                    <th mat-sort-header="groupNo" scope="col">Grp-No</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Action</th>
                                </tr>
                                </thead>
                                <tbody *ngFor="let table of tableData; let i = index; trackBy: trackByPatientId">
                                <tr>
                                    <th scope="row">{{i + 1}}</th>
                                    <td *ngIf="table.batchJobStatus === 'SUCCESS'">
                                        <div class="btn-neon neon-green">
                                            <a class="button success-btn">
                                                <span></span> <span></span> <span></span> <span></span>
                                                Success
                                            </a>
                                        </div>
                                    </td>
                                    <td *ngIf="table.batchJobStatus === 'PENDING'">
                                        <div class="btn-neon neon-yellow">
                                            <a class="button pending-btn">
                                                <span></span> <span></span> <span></span> <span></span>
                                                Pending
                                            </a>
                                        </div>
                                    </td>
                                    <td *ngIf="table.batchJobStatus === 'FAILED'">
                                        <div class="btn-neon neon-red">
                                            <a class="button failed-btn"
                                               matTooltip="{{ table.apiErrorMessage || 'No error details available' }}"
                                               matTooltipPosition="above">
                                                <span></span> <span></span> <span></span> <span></span>
                                                Failed
                                            </a>
                                        </div>
                                    </td>
                                    <td *ngIf="!table.batchJobStatus"><i class="btn-neon neon-gray">-</i></td>
                                    <td *ngIf="this.authService.hasRole('client-edit')"><input type="checkbox"
                                                                                               [checked]="table.assignedF"
                                                                                               (click)="assign(table.id)">
                                    </td>
                                    <td>{{table.staffName ? table.staffName : 'N/A'}}</td>

                                    <td *ngIf="table.verification === 'VERIFIED'">
                                        <div class="btn-neon neon-green">
                                            <button> Verified</button>
                                        </div>
                                    </td>
                                    <td *ngIf="table.verification === 'PENDING'">
                                        <div class="btn-neon neon-yellow">
                                            <button> In Progress</button>
                                        </div>
                                    </td>
                                    <td *ngIf="table.verification === 'NOT_VERIFIED'">
                                        <div class="btn-neon neon-red">
                                            <button> Not Verified</button>
                                        </div>
                                    </td>
                                    <td *ngIf="table.verification === 'BACKLOG'">
                                        <div class="btn-neon neon-gray">
                                            <button> Backlog</button>
                                        </div>
                                    </td>
                                    <td *ngIf="table.verification === 'UNASSIGNED'">
                                        <div class="btn-neon neon-blue">
                                            <button> Unassigned</button>
                                        </div>
                                    </td>
                                    <td *ngIf="!table.verification"><i class="fa-solid fa-circle"
                                                                       style="color: gray"></i></td>

                                    <td>
                                        <a [routerLink]="this.authService.hasRole('client-edit')?['details/', table.id]:null" [queryParams]="{ officeId: table.officeId, planCreation: table.planCreation }">{{table.firstName ? table.firstName + ' ' + table.lastName : '-'}}</a>
                                    </td>
                                    <td>{{ table.dob ? (table.dob | date: 'MM/dd/yyyy') : '-' }}</td>
                                    <td>{{table.patientId ? table.patientId : '-'}}</td>
                                    <td>{{table.formType ? table.formType : '-'}}</td>
                                    <td>{{table.insuranceType ? table.insuranceType : '-'}}</td>
                                    <td>{{table.payerName ? table.payerName : '-'}}</td>
                                    <td>{{table.careerName ? table.careerName : '-'}}</td>
                                    <td>{{table.insuranceId ? table.insuranceId : '-'}}</td>
                                    <td>{{table.insurancePhone ? table.insurancePhone : '-'}}</td>
                                    <td>{{table.apptDate ? (table.apptDate | date:'MM/dd/yyyy') : '-'}}</td>
                                    <td>{{table.apptTime ? table.apptTime : '-'}}</td>
                                    <td>{{table.providerName ? table.providerName : '-'}}</td>
                                    <td>{{table.officeName ? table.officeName : '-'}}</td>
                                    <td>{{table.groupNo ? table.groupNo : '-'}}</td>
                                    <td *ngIf="table.active"><i class="fa-solid fa-square-check"
                                                                style="color: #34ce57"></i></td>
                                    <td *ngIf="!table.active"><i class="fa-solid fa-square-xmark"
                                                                 style="color: #dc3545"></i></td>

                                    <td>
                                        <a title="Edit"
                                           [routerLink]="this.authService.hasRole('client-edit')?['details/', table.id]:null"><i
                                                class="fa-solid fa-user-pen"></i></a>&nbsp;&nbsp;
                                        <a title="Edit"
                                           [routerLink]="this.authService.hasRole('client-edit')?['/userworkarea/details/', table.id]:null" [queryParams]="{form:'patient', officeId: table.officeId, planCreation: table.planCreation}"><i
                                                class="fa-regular fa-eye"></i></a>

                                    </td>
                                </tr>
                                </tbody>
                                <tbody *ngIf="tableData?.length === 0">
                                <tr>
                                    <td colspan="18" class="text-center"> No record found !</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <!--<div *ngIf="tableData.length !== 0" class="d-flex justify-content-end mt-3">
                            <mat-paginator [length]="totalRecord" [pageIndex]="currentPage" [pageSize]="size"
                                           [pageSizeOptions]="[5, 10, 25, 100]"
                                           aria-label="Select page" showFirstLastButtons color="warn"
                                           (page)="pageChange($event)">
                            </mat-paginator>
                        </div>-->
                        <div *ngIf="tableData?.length !== 0" class="d-flex justify-content-end mt-3">
                            <mat-paginator
                                    [length]="totalRecord"
                                    [pageIndex]="pagination.currentPage"
                                    [pageSize]="pagination.size"
                                    [pageSizeOptions]="[5, 10, 25, 100, 200]"
                                    aria-label="Select page"
                                    showFirstLastButtons
                                    color="warn"
                                    (page)="pageChange($event)">
                            </mat-paginator>
                        </div>
                    </div>

            </div>
        </div>
    </div>
</div>

<!-- Bulk Upload Modal -->
<div #bulkUpload class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">Bulk Upload</h3>
                <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <div *ngIf="!fileImage" class="dropzone" (dragover)="onDragOver($event)"
                         (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
                         [ngClass]="{'is-dragover': isDragOver}">
                        <input type="file" #fileDropRef id="fileDropRef" (change)="onFilesSelected($event)"
                               accept=".xls, .xlsx, .xlsm, .xlsb, .xltx, .xltm, .csv, .txt"/>
                        <h3 *ngIf="!fileImage">Drag and drop files here</h3>
                        <label for="fileDropRef" *ngIf="!fileImage">Browse for files</label>
                    </div>
                    <div *ngIf="fileImage" class="image-container">
                        <img [src]="fileImage" alt="Uploaded File" class="uploaded-image"/>
                        <button class="remove-btn" (click)="removeImage()">X</button>
                    </div>

                    <div class="row pt-4" *ngIf="files?.length > 0">
                        <h4>Selected File:</h4>
                        <ul>
                            <li *ngFor="let file of files">{{ file.name }}</li>
                        </ul>
                    </div>
                </form>
            </div>
            <div *ngIf="errorMessagePart" class="error-message">
                <h4>{{ errorMessagePart }}</h4>
                <ul *ngIf="errorMessages.length > 0">
                    <li *ngFor="let error of errorMessages">{{ error }}</li>
                </ul>
            </div>
            <div class="modal-footer">
                <!--                <button type="button" class="btn btn-link download-template" (click)="downloadTemplate()">-->
                <!--                  Download Template-->
                <!--                </button>-->
                <a href="assets/templates/workorder-upload-template.xlsx" download class="btn-slide2">
                    <span class="circle2"><i class="fa fa-download"></i></span>
                    <span class="title2">Download Template</span>
                    <span class="title-hover2">Click here</span>
                </a>
                <button *ngIf="files?.length" type="button" class="btn btn-primary" (click)="uploadFiles()">Upload
                </button>
                <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
            </div>
        </div>
    </div>
</div>

